import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TilesModule } from '../../tiles.module';
import { SharedTileModule } from '../shared/shared-tile.module';
import { ClockTileComponent } from './clock-tile.component';

@NgModule({
   declarations: [ClockTileComponent],
   imports: [CommonModule, TilesModule, SharedTileModule],
   exports: [ClockTileComponent],
})
export class ClockTileModule {}
